import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import NewFooter from '../../components/footer/NewFooter';
import LandingBuyContent from '../../components/landing/LandingBuyContent';
import LandingCarouselContent from '../../components/landing/LandingCarouselContent';
import LandingCertifyContent from '../../components/landing/LandingCertifyContent';
import LandingPageContent from '../../components/landing/LandingPageContent';
import LandingParterContent from '../../components/landing/LandingPartnerContent';
import LandingSellContent from '../../components/landing/LandingSellContent';
import LandingNewsContent from '../../components/landing/LandingNewsContent';
import LandingMediaContent from '../../components/landing/LandingMediaContent';
import NewNavBar from '../../components/navbar/NewNavBar';

import HomePage from '../../pages/Home';
import LoginPage from '../../pages/login/Login';
import PasswordResetPage from '../../pages/login/PasswordReset';
import JobSearch from '../jobs/JobSearch';
import JobDetail from '../jobs/JobDetail';
import JobNavBar from '../jobs/JobNavBar';
import JobProfileDashboard from '../jobs/JobProfileDashboard';
import EmployerJobDashboard from '../jobs/EmployerJobDashboard';
import JobAuthModal from '../jobs/JobAuthModal';
import '../jobs/JobSearch.css';

function GuestLandingPage({
  permitdata,
  popup_register,
  popup_signin,
  callback_signin,
  app_hostname,
  open_register,
  open_signin,
}) {
  const location = useLocation();
  const navigate = useNavigate();

  const [alertMsg, setAlertMsg] = useState('');
  const [currentAuthView, setCurrentAuthView] = useState('login'); // 'login' or 'register'

  const [isJobLoggedIn, setIsJobLoggedInState] = useState(() => {
    return sessionStorage.getItem('meya-job-loggedin') === 'true';
  });
  const [jobUserName, setJobUserNameState] = useState(() => {
    return sessionStorage.getItem('meya-job-username') || '';
  });
  const [jobUserEmail, setJobUserEmailState] = useState(() => {
    return sessionStorage.getItem('job_user_email') || '';
  });

  const setIsJobLoggedIn = (val) => {
    setIsJobLoggedInState(val);
    if (val) {
      sessionStorage.setItem('meya-job-loggedin', 'true');
    } else {
      sessionStorage.removeItem('meya-job-loggedin');
      sessionStorage.removeItem('meya-job-username');
      sessionStorage.removeItem('job_user_email');
      sessionStorage.removeItem('job_token');
      sessionStorage.removeItem('job_user_id');
    }
  };

  const setJobUserName = (val) => {
    setJobUserNameState(val);
    if (val) {
      sessionStorage.setItem('meya-job-username', val);
    } else {
      sessionStorage.removeItem('meya-job-username');
    }
  };

  const setJobUserEmail = (val) => {
    setJobUserEmailState(val);
    if (val) {
      sessionStorage.setItem('job_user_email', val);
    } else {
      sessionStorage.removeItem('job_user_email');
    }
  };

  const handleJobLogout = () => {
    // Clear job session only — do not wipe shop token via callback_signout
    setIsJobLoggedIn(false);
    setJobUserName('');
    setJobUserEmail('');
    sessionStorage.removeItem('job_token');
    sessionStorage.removeItem('job_user_id');
    sessionStorage.removeItem('job_user_email');
    sessionStorage.removeItem('meya-job-loggedin');
    sessionStorage.removeItem('meya-job-username');

    if (isShopMemberLoggedIn) {
      navigate('/marketplace?category=รวมสินค้า');
    } else {
      navigate('/');
    }
  };

  const triggerAlert = (msg) => {
    setAlertMsg(msg);
    setTimeout(() => {
      setAlertMsg('');
    }, 4000);
  };

  useEffect(() => {
    if (!location.pathname.startsWith('/jobs')) return;
    const authMode = new URLSearchParams(location.search).get('auth');
    if (authMode === 'register') {
      setCurrentAuthView('register');
    } else if (authMode === 'login') {
      setCurrentAuthView('login');
    }
  }, [location.pathname, location.search]);

  const isShopMemberLoggedIn = Boolean(
    permitdata &&
      permitdata.role !== 'guest' &&
      permitdata.token !== '' &&
      permitdata.token !== '-' &&
      permitdata.shop_id &&
      permitdata.shop_id !== '-',
  );
  const finalIsJobLoggedIn = isJobLoggedIn || isShopMemberLoggedIn;
  const finalJobUserName = isShopMemberLoggedIn
    ? permitdata.shop_name !== '-'
      ? permitdata.shop_name
      : 'สมาชิกร้านค้า'
    : jobUserName;
  const finalJobUserEmail = isShopMemberLoggedIn
    ? permitdata?.shop_email || ''
    : jobUserEmail || sessionStorage.getItem('job_user_email') || '';

  const isJobsPage = location.pathname.startsWith('/jobs');

  const renderJobAuthModal = () => {
    if (!isJobsPage || finalIsJobLoggedIn) return null;

    return (
      <JobAuthModal
        initialView={currentAuthView}
        app_hostname={app_hostname}
        onClose={() => navigate('/')}
        onAuthSuccess={({ username, email, alertMsg: successMsg }) => {
          if (username) setJobUserName(username);
          if (email) setJobUserEmail(email);
          setIsJobLoggedIn(true);
          if (successMsg) triggerAlert(successMsg);
        }}
      />
    );
  };

  return (
    <div
      className={`page-container${isJobsPage && finalIsJobLoggedIn ? ' jobs-shell' : ''}`}
      style={isJobsPage && finalIsJobLoggedIn ? undefined : { paddingTop: '82px' }}
    >
      <div className='page-wrap'>
        {isJobsPage && finalIsJobLoggedIn ? (
          <JobNavBar
            isJobLoggedIn={finalIsJobLoggedIn}
            onJobLogout={handleJobLogout}
            regName={finalJobUserName}
            permitdata={permitdata}
          />
        ) : (
          <NewNavBar
            islogin={true}
            isreset={true}
            permitdata={permitdata}
            callback_popup_register={open_register}
            callback_popup_signin={open_signin}
          />
        )}

        {isJobsPage && finalIsJobLoggedIn ? (
          <>
            <Routes>
              <Route
                path='/jobs'
                element={
                  <JobSearch
                    permitdata={permitdata}
                    app_hostname={app_hostname}
                    open_signin={open_signin}
                    isUserLoggedIn={finalIsJobLoggedIn}
                    setIsUserLoggedIn={setIsJobLoggedIn}
                    regName={finalJobUserName}
                    setRegName={setJobUserName}
                  />
                }
              />
              <Route
                path='/jobs/detail/:id'
                element={
                  <JobDetail
                    permitdata={permitdata}
                    app_hostname={app_hostname}
                    open_signin={open_signin}
                    isUserLoggedIn={finalIsJobLoggedIn}
                    setIsUserLoggedIn={setIsJobLoggedIn}
                    regName={finalJobUserName}
                    regEmail={finalJobUserEmail}
                    setRegName={setJobUserName}
                  />
                }
              />
              <Route
                path='/jobs/profile'
                element={
                  <JobProfileDashboard
                    regName={finalJobUserName}
                    regEmail={finalJobUserEmail}
                    permitdata={permitdata}
                    app_hostname={app_hostname}
                  />
                }
              />
              <Route
                path='/jobs/employer'
                element={
                  <EmployerJobDashboard permitdata={permitdata} app_hostname={app_hostname} />
                }
              />
            </Routes>
            <NewFooter callback_popup_signin={open_signin} />
          </>
        ) : (
          <>
            <LandingPageContent callback_popup_register={open_register} />
            <LandingBuyContent callback_popup_signin={open_signin} />
            <LandingSellContent callback_popup_signin={open_signin} />
            <LandingCarouselContent />
            <LandingCertifyContent />
            <LandingMediaContent />
            <LandingParterContent />
            <LandingNewsContent />
            <NewFooter callback_popup_signin={open_signin} />

            <Routes>
              <Route path='/home' element={<HomePage permitdata={permitdata} />} />
              <Route
                path='/'
                element={
                  <LoginPage
                    permitdata={permitdata}
                    popup_register={popup_register}
                    popup_signin={popup_signin}
                    callback_signin={(userdata, remember) => {
                      callback_signin(userdata, remember);
                    }}
                    app_hostname={app_hostname}
                  />
                }
              />
              <Route
                exact
                path=''
                element={
                  <LoginPage
                    permitdata={permitdata}
                    popup_register={popup_register}
                    popup_signin={popup_signin}
                    callback_signin={(userdata, remember) => {
                      callback_signin(userdata, remember);
                    }}
                    app_hostname={app_hostname}
                  />
                }
              />
              <Route
                path='/passwordreset/*'
                element={
                  <PasswordResetPage
                    permitdata={permitdata}
                    popup_register={popup_register}
                    popup_signin={popup_signin}
                    callback_signin={(userdata, remember) => {
                      callback_signin(userdata, remember);
                    }}
                    app_hostname={app_hostname}
                  />
                }
              />
            </Routes>
            {renderJobAuthModal()}
          </>
        )}
      </div>

      {isJobsPage && (
        <a
          href='https://line.me/R/ti/p/@meya'
          target='_blank'
          rel='noopener noreferrer'
          className='job-floating-line-btn'
          title='พบปัญหาการใช้งาน ติดต่อ LINE @meya'
        >
          <div className='floating-line-icon-wrap'>
            <i className='mdi mdi-chat-processing-outline'></i>
          </div>
          <span className='floating-line-text'>
            พบปัญหา? LINE <strong>@meya</strong>
          </span>
        </a>
      )}
      {alertMsg && (
        <div className='job-alert-toast-floating'>
          <span>{alertMsg}</span>
        </div>
      )}
    </div>
  );
}

GuestLandingPage.propTypes = {
  permitdata: PropTypes.shape({
    role: PropTypes.string,
    token: PropTypes.string,
    shop_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    shop_name: PropTypes.string,
    shop_email: PropTypes.string,
  }),
  popup_register: PropTypes.bool,
  popup_signin: PropTypes.bool,
  callback_signin: PropTypes.func,
  app_hostname: PropTypes.string,
  open_register: PropTypes.func,
  open_signin: PropTypes.func,
  callback_signout: PropTypes.func,
};

export default GuestLandingPage;
